import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm, getLista
} from './laudoImportacaoActions';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import Td from '../common/table/td';
import FormatUtils from '../common/formatUtils/FormatUtils';
import TBody from '../common/table/tBody';
import DateFormat from '../common/dateFormat/DateFormat';
import ButtonTable from '../common/table/buttonTable';
import SelectDefault from '../common/form/selectDefault';

class LaudoImportacaoForm extends Component {

	state = {
		paginacaoIndice: 0,
	}

    componentWillMount() {
		this.props.getLista(this.props.formularioValues.competencia, this.props.formularioValues.id_hospital);
    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		let lista = this.props.listaItens.map(item => ({
			...item
		}));

		if (this.state.ordenacao == 'nome_radiologista') {
			lista.sort((a, b) => a.nome_radiologista > b.nome_radiologista ? 1 : -1);
		} else if (this.state.ordenacao == 'nome_grupo_faturamento') {
			lista.sort((a, b) => a.nome_grupo_faturamento > b.nome_grupo_faturamento ? 1 : -1);
		} else if (this.state.ordenacao == 'nome_contrato') {
			lista.sort((a, b) => a.nome_contrato > b.nome_contrato ? 1 : -1);
		} else if (this.state.ordenacao == 'nome_hospital_convenio') {
			lista.sort((a, b) => a.nome_hospital_convenio > b.nome_hospital_convenio ? 1 : -1);
		} else if (this.state.ordenacao == 'nome_exame') {
			lista.sort((a, b) => a.nome_exame > b.nome_exame ? 1 : -1);
		} else if (this.state.ordenacao == 'quantidade') {
			lista.sort((a, b) => parseInt(a.quantidade) > parseInt(b.quantidade) ? 1 : -1);
		} else if (this.state.ordenacao == 'valor') {
			lista.sort((a, b) => parseFloat(a.valor) > parseFloat(b.valor) ? 1 : -1);
		} else if (this.state.ordenacao == 'percentual_imposto') {
			lista.sort((a, b) => parseFloat(a.percentual_imposto) > parseFloat(b.percentual_imposto) ? 1 : -1);
		} else if (this.state.ordenacao == 'nome_paciente') {
			lista.sort((a, b) => (a.nome_paciente || '') > (b.nome_paciente || '') ? 1 : -1);
		} else if (this.state.ordenacao == 'datahora_exame') {
			lista.sort((a, b) => a.datahora_exame > b.datahora_exame ? 1 : -1);
		} else if (this.state.ordenacao == 'laudo') {
			lista.sort((a, b) => a.laudo > b.laudo ? 1 : -1);
		} else if (this.state.ordenacao == 'medico_solicitante') {
			lista.sort((a, b) => (a.medico_solicitante || '') > (b.medico_solicitante || '') ? 1 : -1);
		} else if (this.state.ordenacao == 'digitador') {
			lista.sort((a, b) => (a.digitador  || '') > (b.digitador || '') ? 1 : -1);
		}

		let paginacao = [];

		if (lista.length) {
			for (let i = 0; i < lista.length; i += 500) {				
				paginacao.push({
					inicio: i,
					fim: i + 499
				});				
			}
		} else {
			paginacao.push({
				inicio: 0,
				fim: 499
			});
		}

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardHeader>
						<div class='row' style={{ display: 'flex', justifyContent: 'space-between' }}>
							<Grid cols='12 6 3 3'>
								<label style={{ paddingTop: 12 }}>Competência: {FormatUtils.formatarCompetenciaTela(this.props.formularioValues.competencia)}</label>
							</Grid>
							<Grid cols='12 6 6 6'>
								<label style={{ paddingTop: 12 }}>Hospital: {this.props.formularioValues.nome_hospital}</label>
							</Grid>
							<Grid cols='12 6 3 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</div>
					</ContentCardHeader>
					<ContentCardBody>
						<div
							style={{
								marginLeft: -8,
								marginRight: -8,
								marginBottom: -8,
								paddingTop: 1,
								paddingLeft: 8,
								paddingRight: 8,
								paddingBottom: 8,
								height: window.innerWidth < 768 ? '100%' : (window.innerHeight - 150)
							}}>

							<Row>
								<SelectDefault
									options={[
										{ id: 'nome_radiologista', valor: 'Radiologista' },
										{ id: 'nome_grupo_faturamento', valor: 'Grp. Faturamento' },
										{ id: 'nome_contrato', valor: 'Contrato' },
										{ id: 'nome_hospital_convenio', valor: 'Convênio' },
										{ id: 'nome_exame', valor: 'Exame' },
										{ id: 'quantidade', valor: 'Qtd.' },
										{ id: 'valor', valor: 'Valor' },
										{ id: 'percentual_imposto', valor: 'Imposto' },
										{ id: 'nome_paciente', valor: 'Nome do Paciente' },
										{ id: 'datahora_exame', valor: 'Data do Exame' },
										{ id: 'laudo', valor: 'Laudo' },
										{ id: 'medico_solicitante', valor: 'Médico Solicitante' },
										{ id: 'digitador', valor: 'Digitador' }
									]}
									label={null}
									cols='12 12 3 3'
									placeholder='Ordenação'
									value={this.state.ordenacao}
									onChange={data => {
										this.setState({
											ordenacao: data.target.value
										});
									}} />

								<Grid cols='12 12 9 9'>
									<ul class='pagination pagination-sm m-0 float-right'>
										<li class='page-item'>
											<a class='page-link'
												style={{
													cursor: 'pointer'
												}}
												onClick={() => this.setState({
													...this.state,
													paginacaoIndice: this.state.paginacaoIndice > 0 ? this.state.paginacaoIndice - 1 : this.state.paginacaoIndice
												})}>{'<<'}
											</a>
										</li>

										{paginacao.map((item, i) => (
											<li class='page-item'>
												<a class='page-link'
													style={{
														fontWeight: 'bold',
														cursor: 'pointer',
														backgroundColor: i == this.state.paginacaoIndice ? '#007bff' : null,
														color: i == this.state.paginacaoIndice ? '#fff' : null
													}}
													onClick={() => this.setState({
														...this.state,
														paginacaoIndice: i
													})}>{i + 1}
												</a>
											</li>
										))}

										<li class='page-item'>
											<a class='page-link'
												style={{
													cursor: 'pointer'
												}}
												onClick={() => this.setState({
													...this.state,
													paginacaoIndice: paginacao.length - 1 > this.state.paginacaoIndice ? this.state.paginacaoIndice + 1 : this.state.paginacaoIndice
												})}>{'>>'}
											</a>
										</li>
									</ul>
								</Grid>
							</Row>

							<Table responsive border striped alturaFixa
								maxHeight={window.innerWidth < 768 ? '100%' : (window.innerHeight - 200)}>
								<THead backgroundColor={'#ffffff'}>
									<Tr>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Radiologista</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Grp. Faturamento</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Contrato</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Convênio</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Exame</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Qtd.</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Valor</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Imposto</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Nome do Paciente</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Data do Exame</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Laudo</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Médico Solicitante</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}>Digitador</Th>
										<Th alignCenter sticky width={10} backgroundColor={'#ffffff'} color={'#000000'}></Th>
									</Tr>
								</THead>
								<TBody>
									{lista.filter((item, i) => {
										return i >= paginacao[this.state.paginacaoIndice].inicio && i <= paginacao[this.state.paginacaoIndice].fim;
									}).map(item => (
										<Tr key={item.idAux} >
											<Td alignCenter small>{item.nome_radiologista}</Td>
											<Td alignCenter small>{item.nome_grupo_faturamento}</Td>
											<Td alignCenter small>{item.nome_contrato}</Td>
											<Td alignCenter small>{item.nome_hospital_convenio}</Td>
											<Td alignCenter small>{item.nome_exame}</Td>
											<Td alignCenter small>{item.quantidade}</Td>
											<Td alignCenter small>R$ {FormatUtils.formatarValorTela(item.valor, 2)}</Td>
											<Td alignCenter small>{FormatUtils.formatarValorTela(item.percentual_imposto, 2)} %</Td>
											<Td alignCenter small>{item.nome_paciente}</Td>
											<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_exame)}</Td>
											<Td alignCenter small>{item.laudo}</Td>
											<Td alignCenter small>{item.medico_solicitante}</Td>
											<Td alignCenter small>{item.digitador}</Td>
											<Td alignCenter minWidth={50}>																			
												<ButtonTable
													type={'warning'}
													icon={'fas fa-pencil-alt'}
													visible={true}
													small
													event={() => {
														this.props.setModoTela('cadastro', {
															...item,
															quantidade: FormatUtils.formatarValorTela(item.quantidade, 0),
															valor: FormatUtils.formatarValorTela(item.valor, 2),
															percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
														});
														this.props.initForm({
															...item,
															quantidade: FormatUtils.formatarValorTela(item.quantidade, 0),
															valor: FormatUtils.formatarValorTela(item.valor, 2),
															percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
														});
													}} />
												<ButtonTable
													type={'danger'}
													icon={'fas fa-trash-alt'}
													visible={true}
													small
													event={() => {
														this.props.setModoTela('exclusao', {
															...item,
															quantidade: FormatUtils.formatarValorTela(item.quantidade, 0),
															valor: FormatUtils.formatarValorTela(item.valor, 2),
															percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
														});
														this.props.initForm({
															...item,
															quantidade: FormatUtils.formatarValorTela(item.quantidade, 0),
															valor: FormatUtils.formatarValorTela(item.valor, 2),
															percentual_imposto: FormatUtils.formatarValorTela(item.percentual_imposto, 2)
														});
													}} />
											</Td>
										</Tr>
									))}
								</TBody>
							</Table>
						</div>

					</ContentCardBody>
				</Form>
			</ContentCard>
		);
    }


}

LaudoImportacaoForm = reduxForm({form: 'laudoImportacaoForm', destroyOnUnmount: false})(LaudoImportacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('laudoImportacaoForm')(state),
	listaItens: state.laudoImportacao.listaItens
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoImportacaoForm);
